import { commitMutation, graphql } from 'react-relay'

import environment from '../relay/Environment'

const mutation = graphql`
    mutation CreateDeviceExportMutation($export: DeviceExportInput!) {
        deviceExportCreate(input: $export) {
            id
            file
            fileSize
            error
            done
            createdAt
        }
    }
`

export default (predicates, condition, fields) => {
    const variables = {
        export: {
            predicates,
            condition,
            fields,
        },
    }

    return new Promise((resolve, reject) => {
        commitMutation(environment, {
            mutation,
            variables,
            onCompleted: (response, errors) => {
                if (errors) {
                    return reject(errors)
                }
                return resolve(response.deviceExportCreate)
            },
            onError: err => {
                return reject(err)
            },
        })
    })
}
